import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as devicesActionCreators } from "../../../../actions/devicesActions";
import { actionCreators as uiActionCreators } from "../../../../actions/uiActions";
import { actionCreators as widgetConfigActions } from "../../../../actions/widgetConfigActions";
import { actionCreators as sensorHistoActions } from "../../../../actions/sensorHistoActions";

import {
  widgetConsumesHistoData,
  colors,
  maxConnectionsForWidgetType
} from "../../../../helpers/constants";

import {
  deviceSelector,
  resolvedSensorConfigSelector,
  resolvedDataConfigSelector,
  liveSensorValuesSelector
} from "../../../../selectors";

import { Icon } from "react-icons-kit";
import { flash } from "react-icons-kit/entypo/";

import HoverOverlay from "./overlays/HoverOverlay";
import ConnectOverlay from "./overlays/ConnectOverlay";
import MoveOverlay from "./overlays/MoveOverlay";

import { toast } from "react-toastify";

import {LayoutContext} from "../../DashboardComponent";

function wrapWidget(WrappedWidget) {
  class WidgetWrapper extends React.PureComponent {

    componentDidMount() {
      this._node = ReactDOM.findDOMNode(this);
    }

    componentDidUpdate(prevProps){
      let {
        widgetid,
        thisWidgetConfig,
        requestSensorHisto
      } = this.props;

      let consumesHistoData = widgetConsumesHistoData(
        thisWidgetConfig.widget_type
      );
      if (!consumesHistoData) {
        return
      }
      // Request new histo data if interval setting changes
      let {widgetSettings = {}, sensor_slots} = thisWidgetConfig
      let {interval} = widgetSettings

      let {widgetSettings: lastWidgetSettings = {}} = prevProps.thisWidgetConfig
      let {interval: lastInterval} = lastWidgetSettings

      if (interval !== lastInterval) {
        sensor_slots.forEach(sensor_slot => {
          if (sensor_slot.deviceid && sensor_slot.sensorid) {
            requestSensorHisto(widgetid, sensor_slot.deviceid, sensor_slot.sensorid, undefined, undefined, undefined)
          }
        });
      }

    }
    onMouseUp() {
      let {
        ui,
        connectWidgetToSensor,
        widgetid,
        thisWidgetConfig,
        requestSensorHisto
      } = this.props;
      let { drag } = ui;
      let isDrop = drag.active && drag.source;

      if (!isDrop) {
        return;
      }
      let dropSourceType = drag.source.type;
      let isSensorDrop = dropSourceType === "sensor";

      // BAUSTELLE

      if (isDrop && isSensorDrop) {
        let { deviceid, sensorid } = drag.source;

        // Restrict max connections for different widget types
        // Handle the situation, when the number of max connections is reached for a widget.
        // -> Replace last existing connection with new connection? Makes sense for max 1 connection, but for more?

        // Also: prevent from connecting the same sensor twice with a widget.

        let sensorSlots = thisWidgetConfig.sensor_slots;

        // Check for the same sensor already connected to this widget
        let sensorAlreadyConnected = sensorSlots.some(sensorSlot => {
          return (
            sensorSlot.hasOwnProperty("sensorid") &&
            sensorSlot.sensorid === sensorid
          );
        });
        if (sensorAlreadyConnected) {
          toast.error(`Sensor already connected to this widget`);
          return;
        }

        // Check for Max connections
        let maxConnections =
          maxConnectionsForWidgetType[thisWidgetConfig.widget_type] || 2;
        let exceedsMaxConnections = sensorSlots.length + 1 > maxConnections;
        if (exceedsMaxConnections) {
          toast.error(
            `You can only connect ${maxConnections} sensor to this type of widget`
          );
          return;
        }

        connectWidgetToSensor(deviceid, sensorid, widgetid, 0);

        // After a histo-consuming widget is connected, fetch the histo data, since the data for the other widgets was fetched on app start.
        // For histo-consuming widgets connected to multiple sensors, the histo data is fetched here for the last connected sensor.
        let consumesHistoData = widgetConsumesHistoData(
          thisWidgetConfig.widget_type
        );

        if (consumesHistoData) {
          requestSensorHisto(widgetid, deviceid, sensorid, undefined, undefined, undefined);
        }

        toast.success(`Dropped Sensor ${sensorid} of Device ${deviceid}`);
      }
      // BAUSTELLE
    }

    onStartMoveWidget(evt) {
      let { startDrag, widgetid } = this.props;
      let bbox = this._node.getBoundingClientRect();

      let cursorOffsetX = bbox.x - evt.clientX;
      let cursorOffsetY = bbox.y - evt.clientY;

      let dragSource = {
        type: "widget",
        widgetid: widgetid,
        cursorOffsetX,
        cursorOffsetY
      };

      startDrag(200, 100, dragSource);
    }

    onDeleteWidget() {
      let { deleteWidget, widgetid } = this.props;
      deleteWidget(widgetid);
    }

    onResizeWidget(side) {
      console.log("onResizeWidget");
      let { startDrag, widgetid } = this.props;
      let dragSource = {
        type: "widget_resize",
        widgetid,
        side
      };
      startDrag(0, 0, dragSource);
    }

    onToggleWidgetSettings() {
      let { toggleWidgetSettings, widgetid } = this.props;
      toggleWidgetSettings(widgetid);
    }

    // The renderReduces argument is currently used for the chart widget and only takes up a bar at the top
    renderHoverOverlay(renderReduced = false) {
      return (
        <HoverOverlay
          onToggleWidgetSettings={this.onToggleWidgetSettings.bind(this)}
          onStartMoveWidget={this.onStartMoveWidget.bind(this)}
          onDeleteWidget={this.onDeleteWidget.bind(this)}
          onResizeWidget={this.onResizeWidget.bind(this)}
          reducedMode={renderReduced}
        />
      );
    }

    renderConnectOverlay(params) {
      //let {acceptsDrop = false} = params;
      return (
        <ConnectOverlay
          didDrop={() => {
            window.alert("did drop");
          }}
          acceptsDrop
        />
      );
    }

    renderMoveOverlay() {
      return <MoveOverlay />;
    }

    render() {
      let {
        widgetid,
        ui,
        uiConfig,
        thisWidgetConfig,
        resolvedSensorConfig = {},
        resolvedDataConfig = {},
        colorsForSensors
      } = this.props;

      let hovered = ui.hoveredWidget === widgetid;

      // Maybe use later a list of widgets that dont need connections to display.
      let doesNotNeedConnection = thisWidgetConfig && thisWidgetConfig.hasOwnProperty("widget_type") && thisWidgetConfig.widget_type === "imageview";

      let isChartWidget = thisWidgetConfig && thisWidgetConfig.hasOwnProperty("widget_type") && thisWidgetConfig.widget_type === "linechart";
      // DRAG
      let { drag } = ui;
      let { uiMode: editMode } = uiConfig;

      let isDrag = drag.active && drag.source;

      let dragSourceType = undefined;
      let dragSourceId = undefined;
      if (isDrag) {
        dragSourceType = drag.source.type;
      }

      let isWidgetDrag = dragSourceType === "widget";
      let isWidgetResizeDrag =
        dragSourceType === "widget_resize" && drag.source.widgetid === widgetid;

      if (isWidgetDrag || isWidgetResizeDrag) {
        dragSourceId = drag.source.widgetid;
      }

      let isSensorDrop = dragSourceType === "sensor";
      let expectsDrop = drag.active && isSensorDrop && hovered;
      let acceptsDrop = drag.active && isSensorDrop && true;
      let isHovered = !isSensorDrop && hovered && editMode;
      let isDragging =
        (isWidgetDrag || isWidgetResizeDrag) &&
        drag.source.widgetid === widgetid &&
        editMode;
      /*       if (isDragging) {
        isHovered = false;
      } */

      let dimmed =
        uiConfig.uiMode &&
        (!!ui.hoveredWidget && ui.hoveredWidget !== widgetid);

      let widgetClass = "widget";
      widgetClass += dimmed ? " dimmed" : "";
      widgetClass += expectsDrop ? " expectsDrop" : "";
      widgetClass += acceptsDrop ? " acceptsDrop" : "";
      widgetClass += isHovered ? " hovered" : "";
      // raisez class is used to make the widget front most, without being "isHovered". This is used in presentation mode, where widgets cant be "isHovered", but hovered.
      widgetClass += hovered ? " raisez" : "";
      widgetClass += isDragging ? " dragging" : "";
      //

      // Widget Color for Header bg
      let widgetColor;

      if (resolvedSensorConfig.color && resolvedSensorConfig.color.value) {
        widgetColor = resolvedSensorConfig.color.value;
      } else if (resolvedDataConfig.color) {
        widgetColor = resolvedDataConfig.color;
      } else {
        widgetColor = colors["selected"];
      }

      // TEMP
      // CONTENT

      // TODO: put resolvedDataConfigForDevices etc in mapstatetoprops, instead of deifining it here.
      let { devices } = this.props;

      //let headername = "Not Connected";
      let isConnected =
        thisWidgetConfig && thisWidgetConfig.sensor_slots.length > 0;
      let widgetHeaders = [];
      if (isConnected) {
        // Widget headers in a row for all connected sensors.
        widgetHeaders = thisWidgetConfig.sensor_slots.map(sensor_slot => {
          let { deviceid = "NA", sensorid = "NA" } = sensor_slot;
          let device = deviceSelector(devices, deviceid);
          let resolvedDataConfigForDevice = resolvedDataConfigSelector(device);
          let resolvedSensorConfigForDevice = resolvedSensorConfigSelector(
            device,
            sensorid
          );

          let devicename =
            (resolvedDataConfigForDevice && resolvedDataConfigForDevice.name) ||
            deviceid;
          let sensorname =
            (resolvedSensorConfigForDevice &&
              resolvedSensorConfigForDevice.name &&
              resolvedSensorConfigForDevice.name.value) ||
            sensorid;
          let sensorColor = colorsForSensors[sensorid] || widgetColor;
          //console.log("Q1", sensorid,  sensorColor);
          return (
            <div
              className="widget-header"
              style={{ backgroundColor: sensorColor }}
              key={sensorname}
            >
              {`${devicename}, ${sensorname}`}{" "}
            </div>
          );
        });
      }
      //

      let { coords = {} } = this.props;

      let positionStyle = {
        position: "absolute",
        left: coords.x1,
        top: coords.y1,
        width: coords.x2 - coords.x1,
        height: coords.y2 - coords.y1
      };

      let Overlay = null;
      if (isHovered && !isDragging) {
        Overlay = this.renderHoverOverlay(isChartWidget);
      } else if (isDragging) {
        Overlay = this.renderMoveOverlay();
      } else if (expectsDrop) {
        Overlay = this.renderConnectOverlay({acceptsDrop});
      }

      let { widgetSettings = {} } = thisWidgetConfig;
      let renderHeader = !widgetSettings.hideWidgetLabel;

      let widgetContentCssClass = "widget-content";
      widgetContentCssClass += widgetSettings.border_left ? " border-left" : "";
      widgetContentCssClass += widgetSettings.border_right
        ? " border-right"
        : "";
      widgetContentCssClass += widgetSettings.border_top ? " border-top" : "";
      widgetContentCssClass += widgetSettings.border_bottom
        ? " border-bottom"
        : "";

      let { setHoveredWidget } = this.props;

      // For widgets that need the widget size, it is here calculated with taking the borders into account.
      // TODO: -4 is the currently used border_width in css. make this dynamic.
      let widgetSize = {
        width: positionStyle.width + (widgetSettings.border_left ? -4 : 0) +(widgetSettings.border_right ? -4 : 0),
        height: positionStyle.height + (widgetSettings.border_top ? -4 : 0) +(widgetSettings.border_bottom? -4 : 0)
      }

      // Widget height in grid coords
      let widgetGridHeight =
        thisWidgetConfig.gridCoords.gridy2 - thisWidgetConfig.gridCoords.gridy1;
      return (
        <div
          style={positionStyle}
          className={widgetClass}
          onMouseEnter={() => {
            setHoveredWidget(widgetid);
          }}
          onMouseLeave={() => {
            if(!isDragging){ // Prevent deselecting, while dragging (to prevent flashing of wires)
              setHoveredWidget(false);
            }
            
          }}
          onMouseUp={this.onMouseUp.bind(this)}
        >
          {Overlay}

          <div className={widgetContentCssClass}>
            {isConnected || doesNotNeedConnection? (
              <LayoutContext.Consumer>
              {value =>
                <WrappedWidget
                  {...this.props}
                  widgetColor={widgetColor}
                  widgetGridHeight={widgetGridHeight}
                  widgetSize={widgetSize}
                  isMock={false}
                  layout={value}
                /> 
              }
            </LayoutContext.Consumer>
            ) : (
              <Icon size={24} icon={flash} />
            )}
          </div>
          {renderHeader && (
            <div className="widget-header-container">{widgetHeaders}</div>
          )}
        </div>
      );
    }
  }
  const mapStateToProps = (state, ownProps) => {
    let widgetid = ownProps.widgetid;
    let thisWidgetConfig = widgetConfigSelector(state.widgetConfig, widgetid);

    //let sensorSlotConfigs = sensorSlotsConfigSelector(thisWidgetConfig);
    // console.log("sensorSlotConfigs",sensorSlotConfigs)
    let onlySensorSlotConfig = sensorSlotConfigSelector(thisWidgetConfig);

    let { deviceid = 0, sensorid = 0 } = onlySensorSlotConfig;
    let device = deviceSelector(state.devices, deviceid);
    // TEMP: In future a widget can have more than one sensor attached to it.
    let liveSensorValue = liveSensorValuesSelector(device, sensorid);
    // If a piece of metadata is infered by JSON, use resolvedConfig, else use props in sensorconfig.
    let resolvedSensorConfig = resolvedSensorConfigSelector(device, sensorid);

    let resolvedDataConfig = resolvedDataConfigSelector(device);

    // If this widget is of a type, that consumes histo data, include it (for all connected sensors)
    let consumesHistoData = widgetConsumesHistoData(
      thisWidgetConfig.widget_type
    );

    let histoSensorValuesForSensors = {};
    let colorsForSensors = {};
    // TODO: calculate colorsforsensors also for widgets, that dont consume histo data. for now it works,
    // because line chart is the only widget which can have multiple sensors and also happens to consume histo data.
    if (
      consumesHistoData &&
      state.widgetConfig.hasOwnProperty(widgetid) &&
      state.widgetConfig[widgetid].sensor_slots
    ) {
      state.widgetConfig[widgetid].sensor_slots.forEach(sensor_slot => {
        let device =
          sensor_slot.hasOwnProperty("deviceid") &&
          deviceSelector(state.devices, sensor_slot.deviceid);
        if (
          device &&
          sensor_slot.hasOwnProperty("sensorid") &&
          sensor_slot.sensorid
        ) {
          // HISTO VALUES FOR SENSORS
          let histoSensorValuesForSensor = histoSensorDataSelector(
            state.sensorHisto,
            device,
            sensor_slot.sensorid,
            widgetid
          );
          if (histoSensorValuesForSensor) {
            //console.log("33", histoSensorValuesForSensor)
            histoSensorValuesForSensors[
              sensor_slot.sensorid
            ] = histoSensorValuesForSensor;
          }



          // COLORS FOR SENSORS
          let colorForSensor;
          // First try to get from resolvedSensorConfig
          let thisSensorResolvedConfig = resolvedSensorConfigSelector(
            device,
            sensor_slot.sensorid
          );
          if (
            thisSensorResolvedConfig &&
            thisSensorResolvedConfig.color &&
            thisSensorResolvedConfig.color.value
          ) {
            colorForSensor = thisSensorResolvedConfig.color.value;
          } else if (resolvedDataConfig && resolvedDataConfig.color) {
            colorForSensor = resolvedDataConfig.color;
          } else {
            colorForSensor = colors["selected"];
          }
          colorsForSensors[sensor_slot.sensorid] = colorForSensor;
        }
      });
    } else {
      histoSensorValuesForSensors = null;
    }

    //console.log("44", state.widgetConfig[widgetid].sensor_slots)

    return {
      device,
      devices: state.devices,
      liveSensorValue: liveSensorValue,
      histoSensorValuesForSensors,
      resolvedSensorConfig,
      resolvedDataConfig,
      ui: state.ui,
      uiConfig: state.uiConfig,
      //widgetConfig: state.widgetConfig,
      thisWidgetConfig,
      colorsForSensors
    };
  };

  // Single sensor slot // TODO: make special case of multiple sensor slots
  const sensorSlotConfigSelector = singleWidgetConfig => {
    let rv = { deviceid: 0, sensorid: 0 };
    if (
      singleWidgetConfig &&
      singleWidgetConfig.sensor_slots &&
      singleWidgetConfig.sensor_slots.length > 0
    ) {
      rv = singleWidgetConfig.sensor_slots[0];
    }
    return rv;
  };
  // Multiple sensor slots
  // Not yet used!
  // const sensorSlotsConfigSelector = singleWidgetConfig => {
  //   let rv = { deviceid: 0, sensorid: 0 };
  //   if (
  //     singleWidgetConfig &&
  //     singleWidgetConfig.sensor_slots &&
  //     singleWidgetConfig.sensor_slots.length > 0
  //   ) {
  //     rv = singleWidgetConfig.sensor_slots;
  //   }
  //   return rv;
  // };

  const widgetConfigSelector = (widgetConfig, widgetid) => {
    return widgetConfig[widgetid];
  };

  const histoSensorDataSelector = (sensorHisto, device, sensorid, widgetid) => {
    let rv = undefined;
    if (device) {
      let { uid:deviceid, histoSensorValues } = device;

      if (!(sensorHisto[widgetid] && sensorHisto[widgetid][deviceid] && sensorHisto[widgetid][deviceid][sensorid])){
        return [];
      }
      let values = sensorHisto[widgetid][deviceid][sensorid];
      if (!values) {
        return [];
      }
      
      // Add cashed live sensor values (histoSensorValues of device reducer) to sensor histo array
      // TODO: Maybe disable for non 24h intervals
      if (histoSensorValues[sensorid]) {
        values = [...values, ...histoSensorValues[sensorid]]
      }

      rv = values;
    }
    return rv;
  };



  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      { ...devicesActionCreators, ...uiActionCreators, ...widgetConfigActions, ...sensorHistoActions },
      dispatch
    );
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(WidgetWrapper);
}

export default wrapWidget;
